export const INIT_STATE = 'auth/INIT_STATE';
export const SOCKET_CONNECT = 'auth/SOCKET_CONNECT';
export const SOCKET_RECONNECT = 'auth/SOCKET_RECONNECT';
export const SOCKET_CONNECTED = 'auth/SOCKET_CONNECTED';
export const SOCKET_DISCONNECTED = 'auth/SOCKET_DISCONNECTED';

export const AUTH_STRATEGIES = 'auth/AUTH_STRATEGIES';
export const SET_TOKEN = 'auth/SET_TOKEN';

export const REGISTER_START = 'auth/REGISTER_START';
export const REGISTER_COMPLETE = 'auth/REGISTER_COMPLETE';

export const LOGIN_START = 'auth/LOGIN_START';
export const LOGIN_COMPLETE = 'auth/LOGIN_COMPLETE';

export const LOGOUT_START = 'auth/LOGOUT_START';
export const LOGOUT_COMPLETE = 'auth/LOGOUT_COMPLETE';

export const RESET_PASSWORD_COMPLETE = 'auth/RESET_PASSWORD_COMPLETE';
